export const MOBILE_SEAT_MAP_WIDTH = 1200;
export const DESKTOP_SEAT_MAP_WIDTH = 900;
export const DESKTOP_CART_RESERVED_HEIGHT = 72;
export const MOBILE_MAP_BOTTOM_GAP = 8;
